import { GoogleBusinessConnectionOptions } from '../../../../../modals/live-orders/LiveOrdersDrawer';

export default {
  titles: {
    disable: 'Bist du sicher, dass du Live-Bestellungen deaktivieren möchtest?',
    enable: 'Bist du sicher, dass du Live-Bestellungen aktivieren möchtest?',
  },
  form: {
    is_google_business_available: {
      label: 'Google Business verfügbar',
    },
    is_smart_pricing_configured: {
      label: 'Günstigere Preise als Lieferando, Wolt, Uber',
    },
    is_flyers_package_sent: {
      label: 'Werbeflyer versandt',
    },
    is_menu_fully_configured: {
      label: 'Alle Menüpunkte verfügbar',
    },
    has_offers_on_competitor_platforms: {
      label: 'Hat das Restaurant Angebote auf Wolt, Uber, Lieferando (außer kostenloser Lieferung)?',
    },
    is_instagram_story_shared: {
      label: 'Instagram-Story mit dem Eigentümer geteilt',
    },
    is_order_system_connected_to_website: {
      label: 'Foodamigos-Website verbunden ODER Restaurant-eigene Website Online-Bestellbutton hinzugefügt',
    },
    google_business_connected_by: {
      label: 'Wie haben wir Zugang zum Google Business Profile erhalten?',
      options: {
        [GoogleBusinessConnectionOptions.SalesManagerOverEmail]: 'Vertriebsleiter hat google@foodamigos.io eingeladen',
        [GoogleBusinessConnectionOptions.SalesManagerOverPhone]:
          'Vertriebsleiter hat die erste Anfrage selbst vom Telefon des Eigentümers gesendet',
        [GoogleBusinessConnectionOptions.OnboardingManagerOverEmail]:
          'Onboarding-Manager hat Google-Unternehmensprofil angefordert (SM hat weder eingeladen noch Zugriff angefordert)',
      },
    },
  },
  labels: {
    successful_launch:
      'Um einen erfolgreichen Start zu gewährleisten, überprüfe bitte die folgenden offenen Punkte. Das Überprüfen dieser Informationen hilft, mögliche Probleme nach dem Start des Restaurants zu vermeiden.',
    check_errors: 'Überprüfe die Fehler, um einen guten Start des Restaurants sicherzustellen.',
    checkbox_confirmation:
      'Ich bestätige, dass ich die Fehler überprüft habe und der Aktivierung dieses Restaurants zustimme.',
  },
  buttons: {
    check_error: 'Fehler überprüfen',
    confirm_and_activate: 'Bestätigen und Aktivieren',
    cancel: 'Abbrechen',
    yes: 'Ja',
    no: 'Nein',
  },
  errors: {
    name: {
      title: 'Keine arabischen, chinesischen usw. Zeichen im Shopnamen',
      description: 'Der Online-Shopname enthält keine englischen (lateinischen) Zeichen.',
    },
    logo_url: {
      title: 'Logo',
      description: 'Das Logo wurde in den Online-Shop hochgeladen.',
    },
    pictures: {
      title: 'Galeriebild',
      description: '≥ 1 Galeriebild ist im Online-Shop verfügbar.',
    },
    menu_uploaded: {
      title: 'Menü hochgeladen',
      description: '≥ 1 Menü ist verfügbar.',
    },
    opening_hours: {
      title: 'Öffnungszeiten',
      description: '≥ 1 Öffnungszeit wurde hinzugefügt.',
    },
    address: {
      title: 'Restaurant-Adresse',
      description: 'Straße, Stadt, PLZ eingetragen.',
    },
    upsell_items: {
      title: 'Upsell-Artikel',
      description: '≥ 3 Upsell-Artikel wurden ausgewählt.',
    },
    master_promo_code: {
      title: 'Master-Promo-Code',
      description: 'Master-Promo-Code ist verfügbar.',
    },
    flyers_ordered: {
      title: 'Flyer bestellt',
      description: '≥ 1 Flyer-Paket wurde bestellt.',
    },
    test_orders: {
      title: 'Testbestellung gesendet',
      description: '≥ 1 Testbestellung wurde durchgeführt.',
    },
    stripe_billing: {
      title: 'Stripe-Konto',
      description: 'Stripe-Konto verbunden.',
    },
    payments_configured: {
      title: 'Zahlungen konfiguriert',
      description: 'Der Partner hat einen Zahlungsanbieter verbunden — Voraussetzung für den Live-Gang.',
    },
    adyen_merchant_account: {
      title: 'Adyen-Händlerkonto',
      description:
        'Ein aktives Händlerkonto für das Land des Restaurants — Voraussetzung für inländische Kartenkonditionen.',
    },
    payment_rail_covers_country: {
      title: 'Zahlungsweg deckt das Land ab',
      description: 'Die Zahlungskonten des Partners können das Land dieses Restaurants abwickeln.',
    },
    identity: {
      title: 'Restaurant-Identität',
      description: 'Restauranttyp und Küche wurden festgelegt',
    },
    storefront: {
      title: 'Storefront erstellt und Domain verbunden',
      description: 'Nur wenn das Restaurant unsere Website nutzen möchte.',
    },
    google_business: {
      title: 'Google Business',
      description: 'Google Business verbunden',
    },
    billing_payment_method: {
      title: 'Zahlungsmethode',
      description: 'Hinterlegen Sie eine Zahlungsmethode, damit FoodAmigos dieses Restaurant monatlich abrechnen kann.',
    },
    billing_license: {
      title: 'Lizenz',
      description: 'Dieses Restaurant benötigt einen Partner Plan, bevor es live gehen kann.',
    },
    business_name: {
      title: 'Unternehmens- / Restaurantname',
      description: 'Der Name für Nutzungsbedingungen und Datenschutzerklärung ist gespeichert',
    },
    payment_method: {
      title: 'Bar- oder Online-Zahlungen',
      description: 'Barzahlung bei Abholung oder Lieferung ist eingeschaltet oder Online-Zahlungen sind verifiziert',
    },
    stripe_processing_fee: {
      title: 'Verarbeitungsgebühr',
      description: 'Der Partner hat seine Stripe-Verarbeitungsgebühr festgelegt oder eine Marge von 0 % bestätigt',
    },
  },
};
